import React from 'react';

import { Box } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { IoClose } from 'react-icons/io5';

import {
  FOLDER_COLOUR_LABELS,
  FOLDER_COLOUR_OPTIONS,
  FolderColour,
  getFolderColourValue,
} from './folderColour';

interface Props {
  currentColour?: string | null;
  onSelect: (colour: FolderColour | null) => void;
  swatchSize?: number;
  includeNoColour?: boolean;
}

export const FolderColourSwatches: React.FC<Props> = ({
  currentColour = null,
  onSelect,
  swatchSize = 28,
  includeNoColour = true,
}) => {
  const theme = useTheme();

  return (
    <Box display="flex" flexWrap="wrap" gridGap={8}>
      {includeNoColour && (
        <Box
          component="button"
          onClick={() => onSelect(null)}
          aria-label="No colour"
          style={{
            width: swatchSize,
            height: swatchSize,
            borderRadius: '50%',
            border: `2px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.secondary,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            outline: !currentColour ? `2px solid ${theme.palette.primary.main}` : 'none',
            outlineOffset: 2,
            padding: 0,
          }}
        >
          <IoClose size={Math.round(swatchSize / 2)} />
        </Box>
      )}
      {FOLDER_COLOUR_OPTIONS.map(colourKey => {
        const colourValue = getFolderColourValue(theme, colourKey);
        const isSelected = currentColour === colourKey;
        return (
          <Box
            key={colourKey}
            component="button"
            onClick={() => onSelect(colourKey)}
            aria-label={FOLDER_COLOUR_LABELS[colourKey]}
            title={FOLDER_COLOUR_LABELS[colourKey]}
            style={{
              width: swatchSize,
              height: swatchSize,
              borderRadius: '50%',
              border: 'none',
              backgroundColor: colourValue || theme.palette.background.paper,
              cursor: 'pointer',
              outline: isSelected ? `2px solid ${theme.palette.text.primary}` : 'none',
              outlineOffset: 2,
              padding: 0,
            }}
          />
        );
      })}
    </Box>
  );
};
